import * as React from 'react';
import {
  IconToggleLabelPlacement,
  IconToggleOnChangeEvent,
} from '../IconToggle';
import { TPAComponentProps } from '../../types';

export interface LikeButtonProps extends TPAComponentProps {
  label: React.ReactNode;
  labelPlacement: IconToggleLabelPlacement;
  checked: boolean;
  onChange?(event: IconToggleOnChangeEvent): void;
  disabled: boolean;
}

export interface LikeButtonDefaultProps {
  label: React.ReactNode;
  labelPlacement: IconToggleLabelPlacement;
  checked: boolean;
  disabled: boolean;
}
